import React from 'react';
import './AppCard.css';
import { recordAppClick } from '../utils/analytics';

const AppCard = ({ app, onClick, onInfoClick }) => {
  const handleClick = () => {
    // Record the click for analytics
    recordAppClick(app);
    
    if (onClick) {
      onClick(app);
    } else {
      window.open(app.url, '_blank', 'noopener,noreferrer');
    }
  };

  const handleInfoClick = (e) => {
    e.stopPropagation(); // Prevent card click when info button is clicked
    if (onInfoClick) {
      onInfoClick(app);
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleClick();
    }
  };

  return (
    <div
      className={`app-card ${app.featured ? 'featured' : ''}`}
      onClick={handleClick}
      onKeyPress={handleKeyPress}
      tabIndex={0}
      role="button"
      aria-label={`Open ${app.name}`}
    >
      <div className="app-card-header">
        <div className="app-icon">
          {app.category.icon}
        </div>
        <div className="header-right">
          <div 
            className="category-badge"
            style={{ backgroundColor: app.category.color }}
          >
            {app.category.name}
          </div>
        </div>
      </div>
      
      <div className="app-card-content">
        <h3 className="app-title">{app.name}</h3>
        <p className="app-description">{app.description}</p>
        
        {app.tags && app.tags.length > 0 && (
          <div className="app-tags">
            {app.tags.slice(0, 3).map((tag, index) => (
              <span key={index} className="tag">
                {tag}
              </span>
            ))}
            {app.tags.length > 3 && (
              <span className="tag more">+{app.tags.length - 3}</span>
            )}
          </div>
        )}
      </div>
      
      <div className="app-card-footer">
        <div className="launch-indicator">
          <span className="launch-text">Click to launch</span>
          <span className="external-icon">↗</span>
        </div>
        <button 
          className="info-button info-button-bottom"
          onClick={handleInfoClick}
          title="View app information"
          aria-label={`View information about ${app.name}`}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>
          </svg>
        </button>
      </div>
    </div>
  );
};

export default AppCard;